import React from 'react';
import Markdown from 'markdown-to-jsx';
import styles from './homepage-hero.module.scss';
import SearchBar from '../search-bar/search-bar';
import HomepageHeroModel from '../../../models/homepage/HomepageHero';
import { ApplicationSettings } from '../../../models/settings';

type Props = {
  homepageHeroData: HomepageHeroModel;
  applicationSettings: ApplicationSettings;
  currentLocale: string;
  applicationURL: string;
};

export default function HomepageHero({
  homepageHeroData,
  applicationSettings,
  currentLocale,
}: Props) {
  const heroStyling = {
    backgroundColor: homepageHeroData?.backgroundColor ?? `#060C0A`,
  };

  const heroTextColor = {
    color: homepageHeroData?.headingColor ?? `#ffffff`,
  };

  return (
    <>
      {homepageHeroData ? (
        <div id='homepage-hero' className={styles[`home-page-hero`]}>
          <div className={styles['home-page-hero-bg']} style={heroStyling}>
            {homepageHeroData?.backgroundImage ? (
              <img src={homepageHeroData.backgroundImage.secureUrl} alt='Hero image' />
            ) : null}
          </div>
          <div className='container'>
            <div className='row'>
              <div className='col-md-12'>
                <div className={styles[`hero-text`]} style={heroTextColor}>
                  <Markdown>{homepageHeroData?.heading ?? ``}</Markdown>
                </div>
                <div className='col-12 col-md-7 px-0'>
                  <SearchBar
                    idPrefix='typeahead-search'
                    cssWrapper='homepage'
                    typeAheadPlaceHolder='e.g. Business Studies and Finance'
                    applicationSettings={applicationSettings}
                    currentLocale={currentLocale}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      ) : null}
    </>
  );
}
